export default __webpack_public_path__ + "5486ebb56b39d1f1ee971396aa8f872a.png";